import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux'
import {Head, PackageTypeCreate, PackageTypeEdit, RoleCreate} from "../../../components";
import {Box, Paper} from "@mui/material";
import {Tooltip} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";

import {packageTypeAction} from './../../../actions'
import {CURRENT_PACKAGE_TYPE} from "../../../types";


const PackageType = (props) => {

    const { fetchPackageTypes, packageTypeReducer, authReducer} = props;

    const dispatch = useDispatch();

    useEffect(() => {
        handleRequest();
    }, []);

    const handleRequest = () => {
        fetchPackageTypes();
        dispatch({type: CURRENT_PACKAGE_TYPE, payload: null})
    };


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'واحد های اندازه گیری', 'description': 'براساس تعداد و فله مشخص کنید' }} />
            <Box mt={5}>
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                    {authReducer.user.permissions.product && Boolean(authReducer.user.permissions.product.store_package_type_admin) && <PackageTypeCreate reload={() => handleRequest()}/>}
                    {authReducer.user.permissions.product && Boolean(authReducer.user.permissions.product.update_package_type_admin) && packageTypeReducer.entity &&  <PackageTypeEdit checked={packageTypeReducer.entity} reload={() => handleRequest()}/>}
                    <Tooltip title="سینک" onClick={() => handleRequest()}>
                        <IconButton>
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <Paper elevation={1} style={{ padding: '15px'}}>
                    <Grid container>
                        {packageTypeReducer.entities.data && packageTypeReducer.entities.data.map((item, index) => {
                            return(
                                <Grid key={index} item xs={12} sm={3}>
                                    <FormControlLabel key={index} control={
                                        <Radio
                                            checked={(packageTypeReducer.entity ? packageTypeReducer.entity : false ) === item.id}
                                            value={item.id}
                                            onChange={() => dispatch({type: CURRENT_PACKAGE_TYPE, payload: item.id})}
                                        />
                                    } label={item.title ? item.title : item.id} />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Paper>
            </Box>
        </Container>

    );
}


const mapStateToProps = state => ({
    packageTypeReducer: state.packageTypeReducer,
    authReducer: state.authReducer
});

const mapDispatchToProps = (dispatch) => ({
    fetchPackageTypes: () => {
        dispatch(packageTypeAction.fetchPackageType())
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PackageType)
